import { handleError } from 'dde-app/common/utils/api/error';
import config from '../config';

const getConfig = (path: string, defaultValue: any = undefined): any => {
  const separator = '.';

  try {
    return path.replace('[', separator).replace(']', '').split(separator).reduce(
      (accumulator: Record<string, any>, currentValue: string) => accumulator[currentValue],
      config,
    );
  } catch (error) {
    handleError('getConfig error', { error });
    return defaultValue;
  }
};

export {
  getConfig,
};
